import { LoaderCircle } from "lucide-react";

export const Loading = () => (
  <div className="flex w-full h-[75%] items-center justify-center">
    <LoaderCircle className="animate-spin w-16 h-16 text-gray-400" />
  </div>
);
